import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Contact, Vendor, VendorType } from "../types";
import { createVendor } from "../api";
import { getGuid } from "../utils";
import NotificationService from "../components/notification/NotificationService";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../hooks";
import { setVendors } from "../features/appSlice";

interface Props {
  mainVendor: Vendor;
  onClose: () => void;
}

export default function SecondaryDialog(props: Props) {
  const { onClose, mainVendor } = props;

  const vendors = useAppSelector((state) => state.app.vendors);
  const vendorTypes = useAppSelector((state) => state.app.vendorTypes);
  const [filterType, setFilterType] = React.useState<string>("");
  const dispatch = useAppDispatch();

  const vendorTypesSorted = React.useMemo(() => {
    return [...vendorTypes].sort((a, b) => a.name.localeCompare(b.name));
  }, [vendorTypes]);

  const handleAddSecondary = () => {
    const body = {
      id: getGuid(),
      mainVendor: mainVendor.id,
      contact: mainVendor.contact.id,
      visible: true,
      type: filterType,
    };
    createVendor(body)
      .then(() => {
        NotificationService.showToast({
          severity: "success",
          text: "Sekundær virksomhed blev oprettet",
        });
        dispatch(
          setVendors([
            ...vendors,
            {
              ...mainVendor,
              id: body.id,
              mainVendor,
              contact: mainVendor.contact,
              visible: body.visible,
              type: vendorTypesSorted.find((t) => t.id === filterType),
              description: "",
            },
          ])
        );
        onClose();
      })
      .catch(() => {
        NotificationService.showToast({
          severity: "error",
          text: "Der skete en fejl.",
        });
      });
  };

  return (
    <Dialog open onClose={onClose}>
      <DialogTitle>Tilknyt sekundær virksomhed</DialogTitle>
      <DialogContent>
        <DialogContentText>Vælg type for sekundær virksomhed</DialogContentText>
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel>Type</InputLabel>
          <Select
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
          >
            {vendorTypesSorted.map((t) => (
              <MenuItem key={t.id} value={t.id}>
                {t.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Annuller</Button>
        <Button onClick={handleAddSecondary} variant="contained">
          Gem
        </Button>
      </DialogActions>
    </Dialog>
  );
}
